import React, { useContext, useEffect, useRef } from "react";
import { Heading } from "@catchoftheday/cg-components";
import { CustomerContext, CustomerContextProvider } from "@catchoftheday/customer";
import { convertProductCard, ProductGrid } from "@catchoftheday/product-components";
import { useSearchQuery } from "../../../generated/graphql";
import { CatalogueContext, CatalogueContextProvider } from "../../contexts/CatalogueContext.jsx";
import { FacetsZone, HeadingZone, PageLayoutZone, ProductsZone, ResultsZone } from "../../layouts/PageLayout/PageLayout";
import { LoadingSpinner } from "../../pure/LoadingSpinner/LoadingSpinner";
import { SearchSortOptions } from "../../pure/SearchSortOptions/SearchSortOptions";
import { mapSearchInput } from "../../utilities/api";
import { FacetContainer } from "../FacetContainer/FacetContainer";
import { jsx as ___EmotionJSX } from "@emotion/react";

var CatalogueContainerComponent = function CatalogueContainerComponent(_ref) {
  var queryParams = _ref.queryParams;
  var hasMounted = useRef(false);

  var _useContext = useContext(CustomerContext),
      customer = _useContext.data;

  var _useContext2 = useContext(CatalogueContext),
      searchResponse = _useContext2.searchResponse,
      updateSearchResponse = _useContext2.updateSearchResponse,
      updateSearchLoading = _useContext2.updateSearchLoading;

  var query = queryParams.query;
  var searchInput = mapSearchInput(queryParams, customer === null || customer === void 0 ? void 0 : customer.id);

  var _useSearchQuery = useSearchQuery({
    variables: {
      input: searchInput
    },
    skip: !query,
    onCompleted: function onCompleted(data) {
      updateSearchResponse(data.search);
    },
    notifyOnNetworkStatusChange: true
  }),
      initialData = _useSearchQuery.data,
      loading = _useSearchQuery.loading,
      refetch = _useSearchQuery.refetch;

  useEffect(function () {
    updateSearchLoading(loading);
  }, [loading, updateSearchLoading]);
  useEffect(function () {
    if (!hasMounted.current) {
      // Prevent refetch on initial render
      hasMounted.current = true;
      return;
    }

    refetch({
      input: mapSearchInput(queryParams, customer === null || customer === void 0 ? void 0 : customer.id)
    });
  }, [queryParams, refetch, customer === null || customer === void 0 ? void 0 : customer.id]);

  if (!query || !loading && !(initialData !== null && initialData !== void 0 && initialData.search.results.length)) {
    // @TODO: No results page
    return ___EmotionJSX("div", null, "No results");
  }

  var _ref2 = searchResponse || (initialData === null || initialData === void 0 ? void 0 : initialData.search) || {},
      pageTitle = _ref2.pageTitle,
      results = _ref2.results,
      sortOptions = _ref2.sortOptions,
      facets = _ref2.facets;

  var products = results === null || results === void 0 ? void 0 : results.map(function (result) {
    return convertProductCard(result.product, result.product.bestOffer);
  });
  return ___EmotionJSX(PageLayoutZone, null, loading && ___EmotionJSX(LoadingSpinner, null), ___EmotionJSX(HeadingZone, null, ___EmotionJSX(Heading.h1, null, pageTitle), sortOptions && ___EmotionJSX(SearchSortOptions, {
    isLoading: loading,
    options: sortOptions
  })), ___EmotionJSX(ResultsZone, null, ___EmotionJSX(FacetsZone, null, facets && ___EmotionJSX(FacetContainer, {
    facets: facets
  })), ___EmotionJSX(ProductsZone, null, products && ___EmotionJSX(ProductGrid, {
    productItems: products
  }))));
};

export var CatalogueContainer = function CatalogueContainer(_ref3) {
  var queryParams = _ref3.queryParams;
  return ___EmotionJSX(CustomerContextProvider, null, ___EmotionJSX(CatalogueContextProvider, null, ___EmotionJSX(CatalogueContainerComponent, {
    queryParams: queryParams
  })));
};